import React, { Component as C } from "react"

import BaseHeaderRow from "../base-header-row/index.jsx"
import TableHeaderColumn from "@cirrus/legacy/app-components/table-v2/table-header-column/index.jsx"

import commonStyles from "@cirrus/legacy/app-components/table-v2/common-styles/styles.less"

export default class extends C {
  static displayName = "TableHeaderRow"

  render() {
    return (
      <BaseHeaderRow {...this.props}>
        <TableHeaderColumn
          htmlType={this.props.htmlType}
          className={commonStyles.radiobuttonColumn}
        />
        {this.props.children}
      </BaseHeaderRow>
    )
  }
}
